import { useCallback, useEffect, useRef, useState } from 'react'

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click']

export function useInactivityTimer(warningAfterMs, enabled) {
  const [isWarning, setIsWarning] = useState(false)
  const timeoutRef = useRef(null)
  const isWarningRef = useRef(false)

  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }

  const startTimer = useCallback(() => {
    clearTimer()
    timeoutRef.current = setTimeout(() => {
      isWarningRef.current = true
      setIsWarning(true)
    }, warningAfterMs)
  }, [warningAfterMs])

  const reset = useCallback(() => {
    isWarningRef.current = false
    setIsWarning(false)
    startTimer()
  }, [startTimer])

  useEffect(() => {
    if (!enabled) {
      clearTimer()
      return
    }

    startTimer()

    const onActivity = () => {
      if (isWarningRef.current) return
      startTimer()
    }

    ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, onActivity, { passive: true }))

    return () => {
      clearTimer()
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, onActivity))
    }
  }, [enabled, startTimer])

  return { isWarning, reset }
}
